import { createFileRoute } from "@tanstack/react-router";

import { NewExchangePage } from "@/features/Exchanges/NewExchangePage";
import {
  ExchangesFiltersSchema,
  useUpdateExchangesFilter,
  type ExchangesFilters,
} from "@/features/Exchanges/useUpdateExchangesFilter";

export const Route = createFileRoute("/_auth/exchanges/$siteId/new")({
  validateSearch: (raw): ExchangesFilters => ExchangesFiltersSchema.parse(raw),
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { filters, updateFilter } = useUpdateExchangesFilter(Route);

  return (
    <NewExchangePage
      siteId={siteId}
      filters={filters}
      onFilterChange={updateFilter}
    />
  );
}
